import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SeguimientoDTO, IGetSeguimientos } from '../../../shared/interfaces/database/pqrsd';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SeguimientosService {
  private readonly apiUrl = `${environment.apiUrl}/api/pqrsd/seguimientos`;

  constructor(private readonly http: HttpClient) {}

  createSeguimiento(actividadId: number, request: SeguimientoDTO, documentos?: File[]): Observable<boolean> {
    const formData = new FormData();
    formData.append('request', new Blob([JSON.stringify(request)], { type: 'application/json' }));
    
    if (documentos) {
      documentos.forEach(doc => {
        formData.append('documentos', doc);
      });
    }

    return this.http.post<boolean>(`${this.apiUrl}/${actividadId}`, formData);
  }

  getSeguimientos(solicitudActividadId: number): Observable<IGetSeguimientos[]> {
    return this.http.get<IGetSeguimientos[]>(`${this.apiUrl}/${solicitudActividadId}`);
  }
}
